import { IDealAttribute } from 'components/DealForm/types';
import {
    NEW_REPORT_LABELS,
    ReportTypes,
    savedReportTypeMap,
    DEAL_OVERVIEW_ATTRIBUTES,
    REPORT_CLASSNAME_MAP,
} from './constants';
import { DealOverviewAttributes } from './types';

export const getReportTypeFromLabel = (label: string): ReportTypes => {
    const labelToReportTypeMap: Record<string, ReportTypes> = Object.fromEntries(
        Object.entries(NEW_REPORT_LABELS).map(([key, value]) => [value, ReportTypes[key as keyof typeof ReportTypes]]),
    );

    return labelToReportTypeMap[label];
};

export const formatDealHeader = (header: string): string => {
    // Replace camelCase with spaces and sentence case
    const formatted = header.replace(/([A-Z])/g, ' $1').trim(); // Add spaces before capital letters
    return formatted.charAt(0).toUpperCase() + formatted.slice(1).toLowerCase(); // Capitalize the first letter, lowercase the rest
};

export function getReportTypeName(reportType: number): string {
    return savedReportTypeMap[reportType] || 'Unknown report type';
}

export function getReportTypeClassName(reportName: string): string {
    const reportType = getReportTypeFromLabel(reportName);
    return REPORT_CLASSNAME_MAP[reportType] || '';
}

export function buildDealOverviewAttributes(dealAttributes: IDealAttribute[]): DealOverviewAttributes {
    const nameToCorrelationMap = dealAttributes.reduce<Record<string, string>>((acc, attr) => {
        if (attr.name) {
            acc[attr.name.toLowerCase()] = attr.correlationId;
        }
        return acc;
    }, {});

    const staticGroups = Object.entries(DEAL_OVERVIEW_ATTRIBUTES).reduce(
        (acc, [groupKey, attributeNames]) => ({
            ...acc,
            [groupKey]: attributeNames.map(name => ({
                name,
                correlationId: nameToCorrelationMap[name.toLowerCase()] || '',
            })),
        }),
    {} as Omit<DealOverviewAttributes, 'custom'>,
    );

    const custom = dealAttributes
        .filter(attr => attr.isCustom)
        .map(attr => ({
            name: attr.name,
            correlationId: attr.correlationId,
        }));

    return custom.length > 0
        ? { ...staticGroups, custom }
        : staticGroups;
}
